// Types
import { DestinationCategoryState } from '../objects/destinationCategoryState';
import { DestinationCategoriesLocalized } from '../objects/destinationCategoriesLocalized';
// Action Types
import {
    DestinationCategoryActionTypes,
    MOVE_DOWN_COLUMN,
    MOVE_UP_COLUMN,
    RESET_ADD_CATEGORY,
    RESET_FILTERS,
    RESIZE_COLUMN,
    SET_CATEGORY,
    SET_CATEGORY_DELETE,
    SET_COLUMNS,
    SET_EDIT_STEP,
    SET_EXPORT_TYPE,
    SET_LIMIT,
    SET_LIST,
    SET_ORDER_BY,
    SET_PAGE,
    SET_RUNNING,
    SET_SEARCH,
    TOGGLE_CANCEL_MODAL,
    TOGGLE_COLUMN,
    TOGGLE_CREATE,
    TOGGLE_EXPORT,
    TOGGLE_EXPORT_FULL,
    TOGGLE_FILTERS,
    TOGGLE_REFRESH,
    UPDATE_DESTINATION_CATEGORIES_NAME_LOCALE,
    UPDATE_FILTER_CREATED_DATE_GTE,
    UPDATE_FILTER_CREATED_DATE_LTE,
    UPDATE_FILTER_CREATOR,
    UPDATE_FILTER_LAST_AUTHOR,
    UPDATE_FILTER_MODIFIED_DATE_GTE,
    UPDATE_FILTER_MODIFIED_DATE_LTE,
    UPDATE_FILTER_PERIOD,
    UPDATE_FILTER_PERIOD_TYPE
} from './actionTypes';
import { applyColumnResize } from '../../utils/list/utils/columnResize';
import { DEFAULT_DESTINATION_CATEGORY_COLUMNS } from '../utils/setDestinationCategoryPreference';

const initialState: DestinationCategoryState = {
    columns: DEFAULT_DESTINATION_CATEGORY_COLUMNS,
    cancel_modal: false,
    category: null,
    category_delete: null,
    count: 0,
    create: false,
    edit_step: null,
    export_full: false,
    export_list: false,
    export_type: 'CSV',
    destination_categories_name_locales: {},
    filter_created_date_gte: null,
    filter_created_date_lte: null,
    filter_creator: '',
    filter_last_author: '',
    filter_modified_date_gte: null,
    filter_modified_date_lte: null,
    filter_open: false,
    filter_period_type: 0,
    filter_period: 'CREATION',
    limit: 50,
    list: null,
    order_by: 'name',
    order: 'asc',
    page: 0,
    refresh: false,
    running: false,
    search: ''
};

export default (state: DestinationCategoryState = initialState, action: DestinationCategoryActionTypes): DestinationCategoryState => {
    switch (action.type) {
        case MOVE_DOWN_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload + 1] };
            columns[action.payload + 1] = columns[action.payload];
            columns[action.payload + 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case MOVE_UP_COLUMN: {
            const columns = [...state.columns];
            for (let i = 0; i < columns.length; i++) {
                columns[i].last_updated = false;
            }
            const column = { ...columns[action.payload - 1] };
            columns[action.payload - 1] = columns[action.payload];
            columns[action.payload - 1].last_updated = true;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case RESET_ADD_CATEGORY: {
            return {
                ...state,
                cancel_modal: false,
                create: false,
                destination_categories_name_locales: {},
                edit_step: null
            };
        }
        case RESET_FILTERS: {
            return {
                ...state,
                filter_created_date_gte: null,
                filter_created_date_lte: null,
                filter_creator: '',
                filter_last_author: '',
                filter_modified_date_gte: null,
                filter_modified_date_lte: null,
                filter_period: 'CREATION',
                filter_period_type: 0
            };
        }
        case SET_CATEGORY: {
            const destination_categories_name_locales: {} & {[index: string]: any} = {};
            let has_french = false;
            action.payload.localization.map((locale: DestinationCategoriesLocalized) => {
                if (locale.locale === 1) {
                    has_french = true;
                }
                destination_categories_name_locales[locale.locale] = locale.name;
            });
            if (!has_french) {
                destination_categories_name_locales['1'] = action.payload.name !== null ? action.payload.name : '';
            }
            return { ...state, category: action.payload, destination_categories_name_locales: destination_categories_name_locales };
        }
        case SET_CATEGORY_DELETE: {
            if (action.payload === null && state.category_delete !== null && state.list !== null) {
                const list = [...state.list];
                for (let i = 0; i < list.length; i++) {
                    if (list[i].id === state.category_delete.id) {
                        list.splice(i, 1);
                        return { ...state, category_delete: action.payload === false ? null : action.payload, list: list, count: state.count - 1 };
                    }
                }
            }
            return { ...state, category_delete: action.payload === false ? null : action.payload };
        }
        case SET_EDIT_STEP: {
            return { ...state, edit_step: action.payload };
        }
        case SET_EXPORT_TYPE: {
            return { ...state, export_type: action.payload };
        }
        case SET_LIMIT: {
            return { ...state, list: null, limit: action.payload };
        }
        case SET_LIST: {
            const { count, results } = action.payload;
            return { ...state, count: count, list: results, running: false };
        }
        case SET_ORDER_BY: {
            return { ...state, list: null, order_by: action.payload, order: state.order_by === action.payload && state.order === 'asc' ? 'desc': 'asc' };
        }
        case SET_PAGE: {
            return { ...state, list: null, page: action.payload };
        }
        case SET_RUNNING: {
            return { ...state, running: action.payload };
        }
        case SET_SEARCH: {
            return { ...state, list: null, page: 0, search: action.payload };
        }
        case TOGGLE_CANCEL_MODAL: {
            return { ...state, cancel_modal: !state.cancel_modal };
        }
        case TOGGLE_COLUMN: {
            const columns = [...state.columns];
            const column = { ...columns[action.payload] };
            column.checked = !column.checked;
            columns[action.payload] = column;
            return { ...state, columns: columns };
        }
        case TOGGLE_CREATE: {
            return { ...state, create: !state.create };
        }
        case TOGGLE_EXPORT: {
            return { ...state, export_list: action.payload };
        }
        case TOGGLE_EXPORT_FULL: {
            return { ...state, export_full: !state.export_full };
        }
        case TOGGLE_FILTERS: {
            return { ...state, filter_open: !state.filter_open };
        }
        case TOGGLE_REFRESH: {
            return { ...state, refresh: !state.refresh };
        }
        case UPDATE_DESTINATION_CATEGORIES_NAME_LOCALE: {
            const { id, value } = action.payload;
            const destination_categories_name_locales = { ...state.destination_categories_name_locales };
            destination_categories_name_locales[id] = value;
            return { ...state, destination_categories_name_locales: destination_categories_name_locales };
        }
        case UPDATE_FILTER_CREATED_DATE_GTE: {
            return { ...state, filter_created_date_gte: action.payload };
        }
        case UPDATE_FILTER_CREATED_DATE_LTE: {
            return { ...state, filter_created_date_lte: action.payload };
        }
        case UPDATE_FILTER_CREATOR: {
            return { ...state, filter_creator: action.payload };
        }
        case UPDATE_FILTER_LAST_AUTHOR: {
            return { ...state, filter_last_author: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_GTE: {
            return { ...state, filter_modified_date_gte: action.payload };
        }
        case UPDATE_FILTER_MODIFIED_DATE_LTE: {
            return { ...state, filter_modified_date_lte: action.payload };
        }
        case UPDATE_FILTER_PERIOD: {
            const period = action.payload;
            return {
                ...state,
                filter_period: period,
                filter_period_type: 0,
                filter_created_date_gte: period === 'MODIFICATION' ? null : state.filter_created_date_gte,
                filter_created_date_lte: period === 'MODIFICATION' ? null : state.filter_created_date_lte,
                filter_modified_date_gte: period === 'CREATION' ? null : state.filter_modified_date_gte,
                filter_modified_date_lte: period === 'CREATION' ? null : state.filter_modified_date_lte,
            };
        }
        case UPDATE_FILTER_PERIOD_TYPE: {
            return { ...state, filter_period_type: action.payload };
        }
        case SET_COLUMNS: {
            return { ...state, columns: action.payload };
        }
        case RESIZE_COLUMN: {
            return { ...state, columns: applyColumnResize(state.columns, action.payload) };
        }
        default:
            return state;
    }
};
